import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=104fab0b&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=ts"
export * from "./UserManagement.vue?vue&type=script&lang=ts"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=104fab0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104fab0b",
  null
  
)

export default component.exports